import React from "react"
import { Layout, Page } from "@shopify/polaris"
import { useTranslation } from "react-i18next"
import withAuthRequired from "components/auth/withAuthRequired"
import {
  ServiceNowCard,
  EasyVistaCard,
  NexthinkCard,
} from "components/widgets/DeveloperPortal/AssetsImport"
import {
  AzureCard,
  AWSCard,
  GCPCard,
} from "components/widgets/DeveloperPortal/Cloud"
import { VerdiktApiCard } from "components/widgets/DeveloperPortal/VerdiktAPI"
import "stylesheets/DeveloperPortal.scss"

const DeveloperPortalPage = () => {
  const { t } = useTranslation()

  return (
    <Page fullWidth>
      <Layout>
        <Layout.Section>
          <div className="developerPortalPage__header">
            <h1 className="developerPortalPage__title">
              {t("developer_portal:title")}
            </h1>
          </div>
          <div className="developerPortalPage__separator" />
        </Layout.Section>

        <Layout.Section>
          <div className="developerPortalPage__section">
            <div className="developerPortalPage__sectionHeader">
              <h2 className="developerPortalPage__sectionTitle">
                {t("developer_portal:categories.verdikt_api", {
                  defaultValue: "Verdikt API",
                })}
              </h2>
            </div>
            <div className="developerPortalPage__grid">
              <VerdiktApiCard />
            </div>
          </div>

          <div className="developerPortalPage__section">
            <div className="developerPortalPage__sectionHeader">
              <h2 className="developerPortalPage__sectionTitle">
                {t("developer_portal:categories.cloud", { defaultValue: "Cloud" })}
              </h2>
            </div>
            <div className="developerPortalPage__grid">
              <AzureCard />
              <AWSCard />
              <GCPCard />
            </div>
          </div>

          <div className="developerPortalPage__section">
            <div className="developerPortalPage__sectionHeader">
              <h2 className="developerPortalPage__sectionTitle">
                {t("developer_portal:categories.assets", {
                  defaultValue: "Assets",
                })}
              </h2>
            </div>
            <div className="developerPortalPage__grid">
              <ServiceNowCard />
              <EasyVistaCard />
              <NexthinkCard />
            </div>
          </div>
        </Layout.Section>
      </Layout>
    </Page>
  )
}

export default withAuthRequired(DeveloperPortalPage)
